import { Box } from '@shopify/polaris';
import { cn } from '@/lib/utils';
import { Image } from '../Image';
import { Image as ImageType } from '@/types/media';

type SelectableThumbnailProps<T extends ImageType> = {
  image: T;
  selected: boolean;
  imageClassName?: string;
  imageContainerClassName?: string;
  onClick: (image: T) => void;
};

export const SelectableThumbnail = <T extends ImageType>({
  image,
  selected,
  imageContainerClassName,
  imageClassName,
  onClick,
}: SelectableThumbnailProps<T>) => {
  return (
    <Box
      borderWidth="050"
      borderStyle="solid"
      borderColor={selected ? 'border-focus' : 'transparent'}
      borderRadius="200"
      shadow="200"
    >
      <div
        className={cn('relative aspect-[9/16] min-h-[180px] w-full cursor-pointer', imageContainerClassName)}
        onClick={() => onClick(image)}
      >
        <Image
          src={image.src}
          alt={image.name || image.alt || 'thumbnail'}
          fill
          className={cn('rounded-[var(--p-border-radius-100)]', imageClassName)}
          size="xs"
        />
      </div>
    </Box>
  );
};
